import React, { createContext, useState, useEffect } from 'react';
import { apiUrl } from '../utils/api';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [usuario, setUsuario] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);

  const cargarUsuario = async () => {
    const token = localStorage.getItem("token");
    setAuthLoading(true);

    if (token) {
      try {
        const res = await fetch(apiUrl('/auth/users/me/'), {
          headers: {
            Authorization: `Token ${token}`
          }
        });
        if (res.ok) {
          const data = await res.json();
          setUsuario(data);
        } else {
          localStorage.removeItem("token");
          setUsuario(null);
        }
      } catch (error) {
        console.error("Error al cargar usuario:", error);
        setUsuario(null);
      } finally {
        setAuthLoading(false);
      }
    } else {
      setUsuario(null);
      setAuthLoading(false);
    }
  };

  useEffect(() => {
    cargarUsuario();
  }, []);

  return (
    <AuthContext.Provider value={{ usuario, setUsuario, cargarUsuario, authLoading }}>
      {children}
    </AuthContext.Provider>
  );
};
